export default function Cart({ removeFromCart, clearCart }) {
  const cart = JSON.parse(localStorage.getItem("cart")) || [];
  return (
    <div style={{ padding: "20px", color: "black", height:"100vh", width: "100vw" }}>
      <h1>Your Cart</h1>

      {cart.length === 0 ? (
        <p>Cart is empty</p>
      ) : (
        cart.map((item, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ccc",
              marginBottom: "10px",
              padding: "10px",
              borderRadius: "8px",
              background: "rgba(0,0,0,0.4)",
              position: "relative"
            }}
          >
            <img
                src={`https://high-and-fly-1.onrender.com${item.image}`}
                alt={item.name}
                style={{
                  position: "absolute",
                  width: "100px",
                  height: "100px",
                  alignItems: "center",
                  left: "0"
                }}
            />
            {/* RED X BUTTON */}
            <button
              onClick={() => removeFromCart(index)}
              style={{
                position: "absolute",
                top: "5px",
                right: "10px",
                background: "red",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "25px",
                height: "25px",
                cursor: "pointer"
              }}
            ><p style={{position: "absolute", top: "-50%", right: "35%"}}>
              ✕</p>
            </button>

            <h3>{item.name}</h3>
            <p>{item.description}</p>
            <strong>${item.price}</strong>
          </div>
        ))
      )}
      <button name="clear-cart" onClick={clearCart} style={{
        padding: "10px 20px",
        background: "red",
        color: "white",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer"
      }}>Clear Cart</button>
    </div>
  );
}